<template>
  <div class="recordDialog--wrapper" v-if="recordDialogVisible">
    <div class="recordDialog" v-if="recordDialogVisible" ref="recordDialog" :style="dialogStyle">
      <div class="header">
        <h4 class="title" @click="record">录音</h4>
        <div class="header--close  iconfont  icon-close" @click="close" v-show="!isRecording"></div>
      </div>
      <div class="body">
        <div>
          <RecordPanel :disabled="!!errorTips" @error="showError"></RecordPanel>
        </div>
        <div style="height: 30px;margin-top:5px">
          <Volume :volume="vol"></Volume>
        </div>
        <div style="margin-top: 10px" v-show="deviceVisible">
          <h5 style="font-size: 14px;">输入设备</h5>
          <el-select v-model="deviceId" size="mini" style="width: 100%;" @change="deviceChange">
            <el-option v-for="item in devicesList" :label="item.label" :value="item.deviceId"
                       :key="item.deviceId"></el-option>
          </el-select>
        </div>
        <div style="margin-top: 10px">
          <span v-if="errorTips"> <span class="gray"></span>{{ errorTips }} <a href="https://www.aivideo8.com/help?tab=2&menu_id=41&submenu_id=42&id=243" target="_blank">帮助文档</a></span>
          <span v-if="!errorTips && hasPermission" @click="record"><span class="green"></span>麦克风连接成功</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Recorder from 'js-audio-recorder';
import Volume from './Volume';
import RecordPanel from './RecordPanel'
import {mapState, mapMutations} from 'vuex'
import {RecordEnum} from './RecordEnum'

export default {
  name: 'recordDialog',
  data() {
    return {
      deviceId: null,
      devicesList: [],
      recorder: {},
      errorTips: '没有录音设配',
      vol: 0,
      maxVol: 0,
      hasPermission: false,
      isReady: false
    }
  },
  computed: {
    ...mapState('record', ['recordDialogVisible', 'recordStatus', 'left']),
    ...mapState(['timelineHeight']),
    deviceVisible() {
      return this.recordStatus === RecordEnum.RecordInit
    },
    isRecording() {
      return this.recordStatus === RecordEnum.Recording || this.recordStatus === RecordEnum.RecordReady
    },
    dialogStyle() {
      const bottom = `${this.timelineHeight}px`
      const left = this.isRecording ? `${document.body.clientWidth - this.$refs.recordDialog.clientWidth - 5}px` : `${this.left}px`
      return {bottom, left}
    }
  },
  methods: {
    ...mapMutations('record', ['recordDialogHide']),
    close() {
      this.recordDialogHide()
      console.log(this.recordDialogVisible)
    },
    init() {
      this.checkPermission()
    },
    async record() {
      console.log('record')
      this.recorder = new Recorder({
        sampleBits: 16,                 // 采样位数，支持 8 或 16，默认是16
        sampleRate: 48000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
        numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
        // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
      });
      this.recorder.onprogress = (params) => {
        // console.log(params.vol)
        this.vol = params.vol.toFixed(0) - 0
        this.maxVol = Math.max(params.vol, this.maxVol)
        this.volumeCheck()
      }
      try {
        console.log('录音')
        await this.recorder.start()
      } catch (e) {
        console.error(e)
      }
    },
    // 获取麦克风权限
    async checkPermission() {
      console.info('开始')
      try {
        await Recorder.getPermission()
        await this.getDeviceInfo()
        this.hasPermission = true
        this.errorTips = '正在检测设备'
      } catch (error) {
        this.deviceId = null
        this.devicesList = []
        setTimeout(() => {
          this.checkPermission()
        }, 3000)
        if (error.message === 'Requested device not found') {
          this.errorTips = '没有录音设配'
        } else if (error.message === 'Permission denied') {
          this.errorTips = '用户拒绝提供权限'
        }
      }
    },
    // 获取录音设备
    async getDeviceInfo() {
      const res = await navigator.mediaDevices.enumerateDevices()
      console.log(res)
      const list = []
      res.forEach(item => {
        if (item.kind === 'audioinput') {
          list.push(item)
        }
      })
      this.deviceId = 'default'
      this.devicesList = list
    },
    deviceChange(val) {
      console.log(val)
      // todo: 换设备
    },
    volumeCheck() {
      if (this.isReady) return
      this.isReady = true
      this.errorTips = ''
      console.info('开始收音')
    },
    showError(error) {
      if (error.message === 'Requested device not found') {
        this.errorTips = '没有录音设配'
      } else {
        this.errorTips = error.message
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    recordDialogVisible(val) {
      if (val) {
        this.record()
      } else {
        this.recorder.stop()
        this.recorder.destroy().then(() => {
          this.recorder = null
          this.isReady = false
          this.errorTips = '正在检测设备'
        })
      }
    }
  },
  components: {
    Volume,
    RecordPanel
  }

}
</script>
<style lang="scss">
.recordDialog {
  position: absolute;
  width: 390px;
  z-index: 10;
  background: #fff;
  transition: .3s;
  box-shadow: 0px 12px 48px 16px rgba(0,0,0,0.10), 0px 9px 28px 0px rgba(0,0,0,0.10), 0px 6px 16px -8px rgba(0,0,0,0.10);
  border-radius: 2px;

}

</style>
<style lang="scss" scoped>
.recordDialog--wrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
}

.initial {
  left: 595px;
}

.right {
  right: 0;
}

.recordDialog {
  .header {
    height: 44px;
    display: flex;
    justify-content: space-between;
    box-shadow: inset 0 -1px rgba(0, 0, 0, .06);

    .title {
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 18px;
      font-weight: 600;
      padding: 10px 20px;
      color: rgba(0,0,0,0.85);
    }

    &--close {
      font-size: 30px;
      cursor: pointer;
      color: #656667;
      padding: 2px 12px;

      &:hover {
        color: #e57;
      }
    }
  }

  .body {
    overflow: auto;
    padding: 5px 20px 15px;

    .green {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #3CF17E;
      margin-right: 5px;
    }

    .gray {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #aaaaaa;
      margin-right: 5px;
    }
  }
}
</style>